import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon ,MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip,Checkbox  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../../api';

export default class Modalexpercommentbacktbn2sub2 extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",


   id_send:"",
   id_comment:"",
   id_bn:"",
   statuscomment_bn:"",
   filewordcomment_bn:null,

   idarticlebn:'',
   id_articlepsf:'',
   id_empbn:'',
   statusbn:'',
   bn_commentbn:'',
   send_uploadcommentepdfbn:null,

   nameuserbn:'',
   send_uploadewordbn:'',
   send_uploadepdfbn:'',


   Expertpsf:[],
   Expertpsfid:[],
//////
   idarticlebn2:'',
   id_empbn2:'',
   id_articlepsf2:'',
   nameuserbn2:'',
   send_uploadewordbn2:'',
   send_uploadepdfbn2:'',
   send_uploadcommentelistpdfbn2:'',
   checkfile:'',


}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.handleSubmitpass = this.handleSubmitpass.bind(this);
this.getExpert = this.getExpert.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
this.getExpertpsf = this.getExpertpsf.bind(this);
this.handleChangetype2 = this.handleChangetype2.bind(this);
this.handleCheck = this.handleCheck.bind(this);
this.handleSubmitcc = this.handleSubmitcc.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal,
    idarticlebn2:this.props.idarticlebn2,
    id_empbn2:this.props.id_empbn2,
    id_articlepsf2:this.props.id_articlepsf2,
    nameuserbn2:this.props.nameuserbn2,
    send_uploadewordbn2:this.props.send_uploadewordbn2,
    send_uploadepdfbn2:this.props.send_uploadepdfbn2,
    send_uploadcommentelistpdfbn2:this.props.send_uploadcommentelistpdfbn2,

  });
  this.getExpertpsf()

 //this.props.selectex();
}

handleChangetype(event) {    this.setState({bn_commentbn: event.target.value});  }

handleCheck(event) {    this.setState({checkfile: event.target.checked});  }


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);

    const user = { idex: ""};

       this.setState({ id_articlepsf:this.props.id_articlepsf,
                       id_empbn:this.props.id_empbn,
                        idarticlebn:this.props.idarticlebn,
                        nameuserbn:this.props.nameuserbn,
                        send_uploadewordbn:this.props.send_uploadewordbn,
                        send_uploadepdfbn:this.props.send_uploadepdfbn,
                   
        })


  }

  getExpert() {
    setTimeout(() => {
    //  const { id_send } = this.props.id_send
     // this.setState({ id_send:this.props.id_send})
      //ภายใน
       Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expert: res.data})
      }) 

    }, 0);

}


getExpertpsf() {
    setTimeout(() => {
    //  const { id_send } = this.props.id_send
     // this.setState({ id_send:this.props.id_send})
      //ภายใน
       api.get('registercon/Selectexpertpsf')
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expertpsf: res.data})
      }) 

    }, 0);

}

handleChange(event) {    this.setState({statusbn: event.target.value});  }
 // handleChange(event) {    this.setState({fileexpert: event.target.files[0]});  }
  handleChange2(event) {    this.setState({send_uploadcommentepdfbn: event.target.files[0]});  }


  handleSubmitpass() {
    // alert('A name was submitted: ' + this.state.value);


     for (let index = 0; index < this.state.Expertpsfid.length; index++) {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

 //  setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("idarticlebn2", this.state.idarticlebn2);
      datafrm.append("id_articlepsf", this.state.id_articlepsf2);
      datafrm.append("id_empbn", this.state.id_empbn2);
     // datafrm.append("statusbn", this.state.statusbn);
     // datafrm.append("date_senbackbn", dates);
      datafrm.append("nameuserbn", this.state.nameuserbn2); //.ใช้insert ผู้ทรง
      datafrm.append("send_uploadewordbn", this.state.send_uploadewordbn2);
      datafrm.append("send_uploadepdfbn", this.state.send_uploadepdfbn2);
      datafrm.append("dateaddex", dates);
      datafrm.append("statusex", '2');
      datafrm.append("id_expert", this.state.Expertpsfid[index].id_expert);
       datafrm.append("send_uploadcommentelistpdfbn2", this.state.send_uploadcommentelistpdfbn2);

      api.post("registercon/updatebncommentlist2",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
    if (res.data = '200') {
                if (this.state.Expertpsfid.length === index+1) {

                      Swal.fire({
                      title: 'บันทึกข้อเสนอแนะสำเร็จ',
                      text: "Suggestion saved successfully",
                      icon: 'success',
                      showCancelButton: false,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33',
                      confirmButtonText: 'ตกลง'
                    }).then((result) => {
                      if (result.isConfirmed) {
                          this.props.list()
                          this.toggle()
                          window.location.href = '/expertex'
                      }
                    })


                 }

       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })


//}, 1000);

     }

  //this.props.updateat();
 // this.toggle()
  //this.getExpert()

  }



  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);



    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

   // console.log(dates)
   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("idarticlebn", this.state.idarticlebn2);
      datafrm.append("id_articlepsf", this.state.id_articlepsf2);
      datafrm.append("id_empbn", this.state.id_empbn2);
      datafrm.append("nameuserbn", this.state.nameuserbn2);
      datafrm.append("bn_commentbn", this.state.bn_commentbn);
      datafrm.append("statusbn", this.state.statusbn);
      datafrm.append("send_uploadcommentepdfbn", this.state.send_uploadcommentepdfbn);
      datafrm.append("date_senbackbn", dates);

      
      api.post("registercon/Insertfilebncommentlistpsf2",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
  
    if (res.data = '200') {
        Swal.fire({
         title: 'บันทึกข้อเสนอแนะสำเร็จ',
         text: "Suggestion saved successfully",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })
}, 1000);
  }

   handleSubmitcc() {
    // alert('A name was submitted: ' + this.state.value);



    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

   // console.log(dates)
   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("idarticlebn", this.state.idarticlebn2);
      datafrm.append("id_articlepsf", this.state.id_articlepsf2);
      datafrm.append("id_empbn", this.state.id_empbn2);
      datafrm.append("nameuserbn", this.state.nameuserbn2);
      datafrm.append("bn_commentbn", this.state.bn_commentbn);
      datafrm.append("statusbn", this.state.statusbn);
     // datafrm.append("send_uploadcommentepdfbn", this.state.send_uploadcommentepdfbn);
      datafrm.append("date_senbackbn", dates);

      
      api.post("registercon/Insertfilebncommentlistpsf3",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
  
    if (res.data = '200') {
        Swal.fire({
         title: 'บันทึกข้อเสนอแนะสำเร็จ',
         text: "Suggestion saved successfully",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })
}, 1000);
  }




    handleChangetype2(event) {  
                 // this.setState({id_room: event.target.value}); 
                  // const result =  this.state.Articlepass.filter((word) => word.send_type === event.target.value);
                  // this.setState({Articlepassselect:result}); 
                // console.log(event.target.value) 
                const result =  this.state.Expertpsf.filter((word) => word.id_expert === event.target.value);
                console.log(result) 
               this.state.Expertpsfid.push(result[0]);
            // const sd =  this.state.Expertpsfid.push(result[0].id_expert); 
//this.setState({Expertpsfid:sd})

              console.log(this.state.Expertpsfid)
              console.log(this.state.Expertpsf)
            //  console.log(sd)



                                                     const newShareholders = this.state.Expertpsfid.map((std, sidx) => {
                                                      const id = '';
                                                          if (id !== std.id_expert) return std;
                                                          return { ...std, id_expert: result[0].id_expert , name_expert: result[0].name_expert };
                                                        });
                                                    
                                                        this.setState({ Expertpsfid : newShareholders });

                 }

  

    render() {

      // console.log(this.state.Expertpsfid);
      //  console.log(this.state.idarticlebn2)
      //  console.log(this.state.id_articlepsf2)
      //  console.log(this.state.id_empbn2)
      //  console.log(this.state.bn_commentbn)
        console.log(this.state.nameuserbn2)
      
         const itemsartical = this.state.Expertpsf.map((Expertpsf, i) => (
            <option  value={Expertpsf.id_expert} >{Expertpsf.name_expert	}</option>
          ));

        return (
            <>
            <MDBBtn color="deep-purple" onClick={this.toggle} size='sm'>อัพโหลดข้อเสนอแนะ</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>
              อัพโหลดข้อเสนอ
                {/* {this.props.namearticla}{this.props.id_send} */}
                </MDBModalHeader>
              <MDBModalBody>
              <div>

              {/* <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.comment_bn} placeholder="กรุณาระบุจำนวนเงิน" required />
              </div> */}
               <div className="mb-2">
               <label><strong>แจ้งสถานะบทความ</strong></label>
                <select className="browser-default custom-select" onChange={this.handleChange}>
                        <option>------กรุณาเลือกสถานะบทความ------</option>
                        <option value="2">ผ่าน</option>
                        <option value="0">ปรับแก้ไข</option>
                </select>
                </div>

              {/* <p>อัพโหลดไฟล์แบบประเมิน .word</p>
                <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                        success="right"  name="file2" value={this.state.value} onChange={this.handleChange2} required/> */}
           

{this.state.statusbn === '2' ?<>

                         <div className="mb-2">
                            <label><strong>เลือกกรรมการ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangetype2} >
                              <option value="" >---เลือกกรรมการ---</option>
                                {itemsartical}
                                      {/* <option value="s" >dd</option> */}
                                  
                                        
                                         {/* <option value="2" >นำเสนอแบบโปสเตอร์</option> */}
                            </select>
                            </div><br/>

    <MDBTable small>
      <MDBTableHead color="blue-grey lighten-3" textWhite>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์ข้อเสนอแนะ</th>
        
        </tr>
      </MDBTableHead>
        <MDBTableBody>
{this.state.Expertpsfid.map((Expertpsfid,index )  => 
           <tr>
                <td>{index+1}</td>
                 <td>{Expertpsfid.name_expert}</td>
                 
          </tr>
  )}
        </MDBTableBody>
   </MDBTable>



</>:<>

{this.state.statusbn === '0' ?<>
                           <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.bn_commentbn} placeholder="กรุณาระบุข้อเสนอแนะ" required />
                           </div>

                                  <div className="mb-2">
                                    <Checkbox  onChange={this.handleCheck} >แนบไฟล์</Checkbox>
                                  </div>
                           
{this.state.checkfile === true ?<>
<div className="mb-2">
                            <label><strong>อัพโหลดไฟล์แบบประเมิน .pdf <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                        required />
                            </div>
</>:<>

</>}
                           

</>:<></>}
</>}
               
                      
            
              </div>

              </MDBModalBody>

             
              <MDBModalFooter>
               
                {this.state.statusbn === '2'?<>
                <MDBBtn color="primary" onClick={this.handleSubmitpass} >บันทึก</MDBBtn>
                </>:<>
                {this.state.statusbn === '0' ?<>

                 {this.state.checkfile == true   ? <> <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> </> :<>  <MDBBtn color="primary" onClick={this.handleSubmitcc} >บันทึก</MDBBtn></> }
                </>:<>
                <MDBBtn color="primary" disabled >บันทึก</MDBBtn> 
                </>}
                </>}

                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
              
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}


